<template>
  <v-dialog
      v-model="open"
      width="600px"
      overlay-opacity="0.9"
      persistent
  >
    <v-card class="view">
      <v-card-title class="headline">
        ยืนยันการสั่งสินค้า
      </v-card-title>

      <v-card-text>
        <v-container v-if="order">
          <v-row>
            <v-col cols="12">
              <h3 class="mb-2">ที่อยู่จัดส่ง</h3>
              <div v-if="shippingAddress" class="address-box pa-3">
                <div><strong>{{ shippingAddress.name }}</strong></div>
                <div>{{ shippingAddress.address }}</div>
                <div>
                  {{ shippingAddress.district && shippingAddress.district.name }}
                  {{ shippingAddress.city && shippingAddress.city.name }}
                  {{ shippingAddress.province && shippingAddress.province.name }}
                  {{ shippingAddress.zip_code }}
                </div>
                <div v-if="shippingAddress.contact_tel">
                  โทร: {{ shippingAddress.contact_tel }}
                </div>
              </div>
              <div v-else-if="order.customer" class="address-box pa-3">
                <div><strong>{{ order.customer.nickname }}</strong></div>
                <div>{{ order.customer.address }}</div>
                <div>
                  {{ order.customer.district }}
                  {{ order.customer.province }}
                </div>
                <div v-if="order.customer.erp_tel">
                  โทร: {{ order.customer.erp_tel }}
                </div>
              </div>
              <div v-else class="error--text">
                ไม่ได้เลือกที่อยู่จัดส่ง
              </div>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="6">
              <div class="info-box pa-3">เครดิตเทอม :
                <span v-if="order.credit_term === 0">เงินสด</span>
                <span v-else-if="order.credit_term">{{ order.credit_term }} วัน</span>
                <span v-else class="grey--text">ไม่ระบุ</span>
              </div>
            </v-col>

            <v-col cols="6">
              <div class="info-box pa-3">CB 3%:
                <template v-if="order.credit_term === 0">
                  <v-icon v-if="order.project_cb3" color="success" small>mdi-check-circle</v-icon>
                  <v-icon v-else color="grey" small>mdi-close-circle</v-icon>
                  <span class="ml-1">{{ order.project_cb3 ? 'เปิดใช้งาน' : 'ปิด' }}</span>
                </template>
                <template v-else>
                  <v-icon color="grey" small>mdi-minus-circle</v-icon>
                  <span class="ml-1 grey--text">ใช้ไม่ได้</span>
                </template>
              </div>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12">
              <h3 class="mb-2">ยอดรวม</h3>
              <div class="total-box pa-3 text-h5">
                {{ number_format(order.total_net) }} บาท
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-4" color="gray" text @click="onCancel()">
          ยกเลิก
        </v-btn>
        <v-btn class="primary" @click="onConfirm()">
          ยืนยัน
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
.view {
  position: relative;
}

.address-box {
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.info-box {
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  text-align: center;
}

.total-box {
  background-color: #e3f2fd;
  border-radius: 4px;
  border: 2px solid #2196f3;
  text-align: center;
  font-weight: bold;
}
</style>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator'
import {Order} from '../models/Order'
import Helper from '../services/Helper.js'

@Component({
  components: {},
})
export default class OrderConfirmDialog extends Vue {
  open = false
  order: Order | null = null
  onApply: ((order: Order) => void) | null = null

  number_format = Helper.number_format

  get shippingAddress() {
    if (!this.order || !this.order.shipping_address_id) {
      return null
    }

    // Try to get from order.shipping_address first
    if (this.order.shipping_address) {
      return this.order.shipping_address
    }

    // Otherwise, find it in customer.shipping_addresses
    if (this.order.customer && this.order.customer.shipping_addresses) {
      const addresses = this.order.customer.shipping_addresses.filter(
        (addr) => addr.id === this.order!.shipping_address_id
      )
      return addresses.length > 0 ? addresses[0] : null
    }

    return null
  }

  mounted() {
    this.$root.$on('openOrderConfirm', this.onOpen)
  }

  beforeDestroy() {
    this.$root.$off('openOrderConfirm', this.onOpen)
  }

  onOpen(params: { order: Order; onApply: (order: Order) => void }) {
    this.order = params.order
    this.onApply = params.onApply
    this.open = true
  }

  onCancel() {
    this.open = false
    this.order = null
    this.onApply = null
  }

  onConfirm() {
    if (this.onApply && this.order) {
      this.onApply(this.order)
    }
    this.open = false
    this.order = null
    this.onApply = null
  }
}
</script>
